(function () {
  var $ = function (s, root) { return (root || document).querySelector(s); };
  var $$ = function (s, root) { return Array.prototype.slice.call((root || document).querySelectorAll(s)); };
  var money = function (cents) { return '$' + (cents / 100).toFixed(2); };

  // ---- Gallery -------------------------------------------------------------
  var main = $('[data-gallery-main]');
  var thumbs = $$('[data-gallery-thumb]');
  if (main && thumbs.length) {
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        main.src = btn.dataset.src;
        thumbs.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
      });
    });
    var list = $('[data-thumbs]');
    var step = function (dir) { if (list) list.scrollBy({ left: dir * list.clientWidth * 0.8, behavior: 'smooth' }); };
    var prev = $('[data-thumbs-prev]'), next = $('[data-thumbs-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
  }

  // ---- Variants (selects are duplicated in each bundle bar; keep them in sync)
  var vjsonEl = $('[data-variant-json]');
  var current = null;
  var selects = $$('[data-option-select]');
  var setText = function (sel, val) { $$(sel).forEach(function (el) { el.textContent = val; }); };
  if (vjsonEl) {
    var vlist = JSON.parse(vjsonEl.textContent);
    var optionCount = selects.length ? Math.max.apply(null, selects.map(function (s) { return parseInt(s.dataset.index, 10); })) + 1 : 0;
    var selectedValues = function () {
      var vals = [];
      for (var i = 0; i < optionCount; i++) {
        var s = selects.filter(function (x) { return parseInt(x.dataset.index, 10) === i; })[0];
        vals.push(s ? s.value : null);
      }
      return vals;
    };
    var applyVariant = function () {
      var opts = selectedValues();
      var v = null;
      for (var i = 0; i < vlist.length; i++) {
        var match = true;
        for (var j = 0; j < opts.length; j++) { if (vlist[i].options[j] !== opts[j]) { match = false; break; } }
        if (match) { v = vlist[i]; break; }
      }
      if (!v) return;
      current = v;
      $$('input[name="id"]').forEach(function (inp) { inp.value = v.id; });
      var form = $('[data-atc-form]');
      if (form) form.dataset.variant = v.id;
      var compare = v.compare_at_price || v.price;
      setText('[data-b1-price]', money(v.price));
      setText('[data-b1-compare]', money(compare));
      var p2 = Math.round(v.price * 2 * 0.85), p3 = Math.round(v.price * 3 * 0.75);
      setText('[data-b2-price]', money(p2)); setText('[data-b2-compare]', money(compare * 2)); setText('[data-b2-each]', money(Math.round(p2 / 2)));
      setText('[data-b3-price]', money(p3)); setText('[data-b3-compare]', money(compare * 3)); setText('[data-b3-each]', money(Math.round(p3 / 3)));
      var btn = $('[data-atc-button]');
      if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? 'Add to cart' : 'Sold out'; }
    };
    selects.forEach(function (s) {
      s.addEventListener('change', function () {
        // mirror the value into the same-index select in every other bar
        selects.forEach(function (o) { if (o !== s && o.dataset.index === s.dataset.index) o.value = s.value; });
        applyVariant();
      });
    });
    if (optionCount) applyVariant(); else current = vlist[0];
  }

  // ---- Bundle bars → quantity ----------------------------------------------
  var bundles = $('[data-bundles]');
  var qtyInput = $('[data-bundle-qty]');
  if (bundles) {
    $$('input[name="bundle"]', bundles).forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (qtyInput) qtyInput.value = radio.value;
        $$('.bar', bundles).forEach(function (bar) { bar.classList.toggle('is-selected', bar.contains(radio)); });
      });
    });
  }

  // ---- Add to cart (main product × qty + checked add-ons) -------------------
  var atcForm = $('[data-atc-form]');
  if (atcForm) {
    atcForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var items = [{ id: parseInt(atcForm.dataset.variant, 10), quantity: parseInt((qtyInput && qtyInput.value) || '1', 10) }];
      $$('[data-addon]:checked').forEach(function (box) { items.push({ id: parseInt(box.value, 10), quantity: 1 }); });
      var btn = $('[data-atc-button]');
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); window.location.href = '/cart'; })
        .catch(function () { if (btn) btn.disabled = false; atcForm.submit(); });
    });
  }

  // ---- Shipping checkpoints (real dates from today) -------------------------
  var fmt = function (d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); };
  $$('[data-date-range]').forEach(function (el) {
    var parts = el.dataset.dateRange.split(',').map(Number);
    var a = new Date(), b = new Date();
    a.setDate(a.getDate() + parts[0]); b.setDate(b.getDate() + parts[1]);
    el.textContent = fmt(a) + ' – ' + fmt(b);
  });

  // ---- Inline review carousel ----------------------------------------------
  var carousel = $('[data-inline-reviews]');
  if (carousel) {
    var slides = $$('.inline-review', carousel);
    var dots = $('[data-dots]', carousel);
    var idx = 0;
    var show = function (i) {
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === idx); });
      $$('button', dots).forEach(function (d, k) { d.classList.toggle('is-active', k === idx); });
    };
    slides.forEach(function (_, k) {
      var d = document.createElement('button'); d.type = 'button'; d.setAttribute('aria-label', 'Review ' + (k + 1));
      d.addEventListener('click', function () { show(k); });
      dots.appendChild(d);
    });
    show(0);
    if (slides.length > 1) setInterval(function () { show(idx + 1); }, 6000);
  }

  // ---- Quantity steppers (cart page) ---------------------------------------
  $$('.qty').forEach(function (qty) {
    var input = $('input', qty);
    $$('button', qty).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, v + (btn.dataset.dir === 'up' ? 1 : -1));
      });
    });
  });
})();
